export default "__VITE_ASSET__C8Mgq7CP__"